import React from 'react';
import PropTypes from 'prop-types';
import { ResponsivePie } from '@nivo/pie';

import './DashboardPieChart.css';
import { flatColors } from '../../../config/chartColors';

const DashboardPieChart = (props) => {
  return (
    <div style={{ height: '24rem' }}>
      <ResponsivePie
        data={props.data}
        margin={{
          top: 30,
          right: 70,
          bottom: 30,
          left: 70,
        }}
        innerRadius={0.5}
        colors={flatColors}
        colorBy="id"
        sortByValue
        borderWidth={1}
        borderColor="inherit"
        radialLabel="label"
        radialLabelsSkipAngle={6}
        radialLabelsTextXOffset={2}
        radialLabelsTextColor="#333333"
        radialLabelsLinkOffset={0}
        radialLabelsLinkDiagonalLength={10}
        radialLabelsLinkHorizontalLength={4}
        radialLabelsLinkStrokeWidth={2}
        radialLabelsLinkColor="inherit"
        sliceLabel={props.tooltipTextFn}
        slicesLabelsSkipAngle={0}
        slicesLabelsTextColor="inherit:darker(1.2)"
        animate
        motionStiffness={90}
        motionDamping={15}
        tooltip={props.tooltipTextFn}
        // legends={[
        //  {
        //    anchor: 'right',
        //    direction: 'column',
        //    translateY: 56,
        //    itemWidth: 100,
        //    itemHeight: 18,
        //    symbolSize: 10,
        //    symbolShape: 'circle',
        //    legendLabel: 'label',
        //  },
        // ]}
      />
    </div>
  );
};

DashboardPieChart.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.array.isRequired,
  tooltipTextFn: PropTypes.func,
};

DashboardPieChart.defaultProps = {
  tooltipTextFn: v => v.value,
};

export default DashboardPieChart;



// WEBPACK FOOTER //
// ./src/components/pages/dashboard/DashboardPieChart.jsx